import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import { isFileNameInvalid, sanitizedFile } from 'lib/file-sanitization'

const axiosRequest = (extraParams: any = {}) =>
  AxiosInitializer({
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  })

const fileUploadAPI = {
  uploadFile: (file: File, params = {}) => {
    const formData = new FormData()
    formData.append(
      'data[attributes][file]',
      isFileNameInvalid(file) ? sanitizedFile(file) : file,
    )

    return apiWrapper({
      endPoint: () =>
        axiosRequest().post('/file_uploads', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
      params,
      errorFailureAction: handleStatus500,
    })
  },
}

export default fileUploadAPI
